<template>
    <div class="contain">
        <div class="box ">
            <div class="left">
                <div class="nav xy-between">
                    <div class="xy-between">
                        <div
                            class="font-size16 cursor back"
                            @click="returnback"
                        >
                            <i class="el-icon-back font-size18 "></i>
                            返回
                        </div>
                        <div class="throw"></div>
                        <div
                            class="tit font-size16 font-weight"
                            v-html="passColumName"
                        ></div>
                    </div>

                    <div class="topicNum">
                        <span class="font-size24 c-256CF4">{{
                            currentOrder + 1
                        }}</span
                        >/
                        <span class="font-size16 c-868EA1">{{
                            allTopicNum
                        }}</span
                        >题
                    </div>
                </div>
                <!-- <make-topic :topic-info="count"></make-topic> -->
                <!-- 做题 -->
                <div class="twoBox">
                    <div class="topicContain" v-if="orginObj">
                        <div class="topicNav ">
                            <div class="tit ">
                                <div class="font-size14 topicType c-256CF4">
                                    [{{
                                        orginObj.SubjectType === "1"
                                            ? "单选题"
                                            : orginObj.SubjectType === "2"
                                            ? "多选题"
                                            : orginObj.SubjectType === "3"
                                            ? "填空题"
                                            : orginObj.SubjectType === "4"
                                            ? "判断题"
                                            : orginObj.SubjectType === "5"
                                            ? "问答题"
                                            : orginObj.SubjectType === "6"
                                            ? "复合题"
                                            : ""
                                    }}]
                                </div>
                                <div
                                    class="font-size18 topicContent"
                                    v-if="orginObj.stem"
                                    v-html="orginObj.stem"
                                ></div>
                            </div>
                            <!-- <div @click="collection">
                                <i v-if="!orginObj.collect" class="iconfont icon-shoucang font-size24 c-E5E8EC"></i>
                                <i v-else class="iconfont icon-shoucang font-size24 c-FFD251"></i>
                            </div> -->
                        </div>
                        <div class="allTopics">
                            <!-- 单选题 -->
                            <div
                                class="sigleSelect "
                                v-if="orginObj.SubjectType === '1'"
                            >
                                <div class="topics">
                                    <div
                                        class="topicItem jf cursor"
                                        v-for="(singleItem,
                                        index) in orginObj.answer"
                                        :key="index"
                                        @click="
                                            selectSingleAnswer(
                                                singleItem,
                                                orginObj.answer
                                            )
                                        "
                                    >
                                        <div
                                            class="options xy-center cursor multiple "
                                            v-html="singleItem.option"
                                            :class="{
                                                singleActive:
                                                    singleItem.rankStyle,
                                                makeRightStyle:
                                                    singleItem.origlRight,
                                                isErrorActive:
                                                    singleItem.userIsErrStyle
                                            }"
                                        ></div>
                                        <div
                                            class="content  font-size14"
                                            v-html="singleItem.content"
                                        ></div>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        v-if="
                                            orginObj.status &&
                                                orginObj.showAnwser
                                        "
                                        class="parsingBox"
                                    >
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    正确答案：
                                                    <div
                                                        class="c-00B37C font-size18"
                                                        v-for="(singleItem,
                                                        index) in orginObj.answer"
                                                        :key="index"
                                                    >
                                                        <div
                                                            class=""
                                                            v-if="
                                                                singleItem.rightFlag ===
                                                                    '1'
                                                            "
                                                        >
                                                            <div
                                                                v-html="
                                                                    singleItem.option
                                                                "
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    您的答案：
                                                    <!-- <div class="c-00B37C font-size18"
                                                        v-for="(singleItem,index) in orginObj.answer" :key="index">
                                                        <div class="" v-if="singleItem.rankStyle">
                                                            <div v-html="singleItem.option"></div>
                                                        </div>
                                                    </div> -->
                                                    <div
                                                        class="c-00B37C font-size18"
                                                    >
                                                        {{
                                                            TransformAnswer(
                                                                orginObj.userSelectAnswer
                                                            )
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <div class="parsing">
                                            <div class="tit jf">
                                                <div class="cyc"></div>
                                                <div class="text c-72777F">
                                                    解析
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    class="text"
                                                    v-if="orginObj.analysis"
                                                    v-html="orginObj.analysis"
                                                ></div>
                                                <div v-else class="text">
                                                    暂无解析
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="notParsingBox"></div>
                                </div>
                            </div>
                            <!-- 多选题 -->
                            <div
                                class="multiSelect "
                                v-else-if="orginObj.SubjectType === '2'"
                            >
                                <div class="topics">
                                    <div
                                        class="topicItem jf cursor"
                                        v-for="(singleItem,
                                        index) in orginObj.answer"
                                        :key="index"
                                        @click="
                                            selectSomeAnswer(
                                                singleItem,
                                                orginObj.answer
                                            )
                                        "
                                    >
                                        <div
                                            class="options xy-center cursor multiple "
                                            v-html="singleItem.option"
                                            :class="{
                                                singleActive:
                                                    singleItem.rankStyle,
                                                makeRightStyle:
                                                    singleItem.origlRight,
                                                isErrorActive:
                                                    singleItem.userIsErrStyle
                                            }"
                                        ></div>
                                        <div
                                            class="content  font-size14"
                                            v-html="singleItem.content"
                                        ></div>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        v-if="
                                            orginObj.status &&
                                                orginObj.showAnwser
                                        "
                                        class="parsingBox"
                                    >
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    正确答案：
                                                    <div
                                                        class="c-00B37C font-size18"
                                                        v-for="(singleItem,
                                                        index) in orginObj.answer"
                                                        :key="index"
                                                    >
                                                        <div
                                                            class=""
                                                            v-if="
                                                                singleItem.rightFlag ===
                                                                    '1'
                                                            "
                                                        >
                                                            <div
                                                                v-html="
                                                                    singleItem.option
                                                                "
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    您的答案：
                                                    <!-- <div class="c-00B37C font-size18"
                                                        v-for="(singleItem,index) in orginObj.answer" :key="index">
                                                        <div class="" v-if="singleItem.rankStyle">
                                                            <div v-html="singleItem.option"></div>
                                                        </div>
                                                    </div> -->
                                                    <div
                                                        class="c-00B37C font-size18"
                                                    >
                                                        {{
                                                            TransformAnswer(
                                                                orginObj.userSelectAnswer
                                                            )
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <div class="parsing">
                                            <div class="tit jf">
                                                <div class="cyc"></div>
                                                <div class="text c-72777F">
                                                    解析
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    class="text"
                                                    v-if="orginObj.analysis"
                                                    v-html="orginObj.analysis"
                                                ></div>
                                                <div v-else class="text">
                                                    暂无解析
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="notParsingBox"></div>
                                </div>
                            </div>
                            <!-- 填空题 -->
                            <div
                                class="fillBlank"
                                v-else-if="orginObj.SubjectType === '3'"
                            >
                                <div
                                    class="fillBlankItem"
                                    v-for="(singleItem,
                                    index) in orginObj.answer"
                                    :key="index"
                                >
                                    <div
                                        class="font-size14 c-333333 fillBlanktext"
                                    >
                                        填空{{ index + 1 }}
                                    </div>
                                    <div class="fillBlankField">
                                        <el-input
                                            v-if="!orginObj.status"
                                            resize="none"
                                            v-model="singleItem.rankStyle"
                                            @change="FillIuput"
                                            rows="1"
                                            autosize
                                            type="textarea"
                                            placeholder="请在此输入您的答案"
                                        ></el-input>
                                        <el-input
                                            v-else
                                            readonly
                                            v-model="singleItem.rankStyle"
                                            rows="1"
                                            autosize
                                            type="textarea"
                                            placeholder="答案"
                                        ></el-input>
                                    </div>
                                </div>
                                <div
                                    class="confrimBtn xy-center font-size16 cursor"
                                >
                                    <!-- 确定 -->
                                </div>
                                <div
                                    v-if="
                                        orginObj.status && orginObj.showAnwser
                                    "
                                    class="parsingBox"
                                >
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf">
                                            <div class="right ">
                                                <div
                                                    style="margin-bottom:20px;color:#00B37C"
                                                >
                                                    正确答案：
                                                </div>
                                                <div
                                                    v-for="(singleItem,
                                                    index) in orginObj.answer"
                                                    :key="index"
                                                >
                                                    <div
                                                        v-html="
                                                            singleItem.content
                                                        "
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <div class="parsing">
                                        <div class="tit jf">
                                            <div class="cyc"></div>
                                            <div class="text c-72777F">
                                                解析
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="text"
                                                v-if="orginObj.analysis"
                                                v-html="orginObj.analysis"
                                            ></div>
                                            <div v-else class="text">
                                                暂无解析
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 判断题 -->
                            <div
                                class="judgeTopic "
                                v-else-if="orginObj.SubjectType === '4'"
                            >
                                <div class="topics">
                                    <div
                                        class="topicItem jf cursor"
                                        v-for="(singleItem,
                                        index) in orginObj.answer"
                                        :key="index"
                                        @click="
                                            selectSingleAnswer(
                                                singleItem,
                                                orginObj.answer
                                            )
                                        "
                                    >
                                        <div
                                            class="options xy-center cursor multiple "
                                            v-html="singleItem.option"
                                            :class="{
                                                singleActive:
                                                    singleItem.rankStyle,
                                                makeRightStyle:
                                                    singleItem.origlRight,
                                                isErrorActive:
                                                    singleItem.userIsErrStyle
                                            }"
                                        ></div>
                                        <div
                                            class="content  font-size14"
                                            v-html="singleItem.content"
                                        ></div>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        v-if="
                                            orginObj.status &&
                                                orginObj.showAnwser
                                        "
                                        class="parsingBox"
                                    >
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    正确答案：
                                                    <div
                                                        class="c-00B37C font-size18"
                                                        v-for="(singleItem,
                                                        index) in orginObj.answer"
                                                        :key="index"
                                                    >
                                                        <div
                                                            class=""
                                                            v-if="
                                                                singleItem.rightFlag ===
                                                                    '1'
                                                            "
                                                        >
                                                            <div
                                                                v-html="
                                                                    singleItem.option
                                                                "
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    您的答案：
                                                    <!-- <div class="c-00B37C font-size18"
                                                        v-for="(singleItem,index) in orginObj.answer" :key="index">
                                                        <div class="" v-if="singleItem.rankStyle">
                                                            <div v-html="singleItem.option"></div>
                                                        </div>
                                                    </div> -->
                                                    <div
                                                        class="c-00B37C font-size18"
                                                    >
                                                        {{
                                                            TransformAnswer(
                                                                orginObj.userSelectAnswer
                                                            )
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <div class="parsing">
                                            <div class="tit jf">
                                                <div class="cyc"></div>
                                                <div class="text c-72777F">
                                                    解析
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    class="text"
                                                    v-if="orginObj.analysis"
                                                    v-html="orginObj.analysis"
                                                ></div>
                                                <div v-else class="text">
                                                    暂无解析
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="notParsingBox"></div>
                                </div>
                            </div>
                            <!-- 简答题 -->
                            <div
                                class="fillBlank"
                                v-else-if="orginObj.SubjectType === '5'"
                            >
                                <div
                                    class="fillBlankItem"
                                    v-for="(singleItem,
                                    index) in orginObj.answer"
                                    :key="index"
                                >
                                    <div class="fillBlankField">
                                        <el-input
                                            v-if="!orginObj.status"
                                            resize="none"
                                            v-model="singleItem.rankStyle"
                                            @change="FillIuput"
                                            rows="1"
                                            autosize
                                            type="textarea"
                                            placeholder="请在此输入您的答案"
                                        ></el-input>
                                        <el-input
                                            v-else
                                            readonly
                                            v-model="singleItem.rankStyle"
                                            rows="1"
                                            autosize
                                            type="textarea"
                                            placeholder="答案"
                                        ></el-input>
                                    </div>
                                </div>
                                <div
                                    class="confrimBtn xy-center font-size16 cursor"
                                >
                                    <!-- 确定 -->
                                </div>
                                <div
                                    v-if="
                                        orginObj.status && orginObj.showAnwser
                                    "
                                    class="parsingBox"
                                >
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf">
                                            <div class="right ">
                                                <div style="margin-bottom:20px">
                                                    正确答案：
                                                </div>
                                                <div
                                                    v-for="(singleItem,
                                                    index) in orginObj.answer"
                                                    :key="index"
                                                >
                                                    <div
                                                        v-html="
                                                            singleItem.content
                                                        "
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <div class="parsing">
                                        <div class="tit jf">
                                            <div class="cyc"></div>
                                            <div class="text c-72777F">
                                                解析
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="text"
                                                v-if="orginObj.analysis"
                                                v-html="orginObj.analysis"></div>
                                            <div v-else class="text">
                                                暂无解析
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom xy-between">
                        <div class="left jf">
                            <div
                                class="btn xy-center cursor font-size16"
                                @click="preTopic"
                            >
                                上一题
                            </div>
                            <div
                                class="btn xy-center next cursor font-size16"
                                @click="nextTopic"
                            >
                                下一题
                            </div>
                        </div>

                        <div class="rightSave">
                            <div class="save xy-center" @click="testOver">
                                <div>
                                    <i class="el-icon-bank-card"></i>
                                    <span>立即交卷</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 做题 -->
            </div>
            <div class="rightSheet">
                <sheet-card
                    v-if="passList && passList.length"
                    ref="sheetCard"
                    :info="topicInfo"
                    :is-do="isHaveDo"
                    :serial-number="currentOrder + 1"
                    :list="passList"
                    :is-submit="isHaveSubmit"
                    :test-over="overList"
                    @jumoTopic="jumpSheet"
                >
                </sheet-card>
            </div>
        </div>
        <el-dialog
            title=""
            :visible.sync="centerDialogVisible"
            width="25%"
            center
        >
            <div v-if="!isSubMitPaper" class="yx-center">
                <div class="isOver xy-center font-size18">是否交卷？</div>
                <div slot="footer" class="isOverfooter">
                    <el-button @click="cancelTestPaper">取消</el-button>
                    <el-button type="primary" @click="confrimPaper"
                        >交卷</el-button
                    >
                </div>
            </div>
            <div v-else class="yx-center">
                <div class="overText yx-center font-size18">
                    <div class="text font-size16">
                        当前客观题答对{{ makeRight }}道，答错{{
                            makeErr
                        }}道，还剩{{ totalTopic }}道没做,是否查看答案？
                    </div>
                    <!-- <div></div>  -->
                </div>
                <div slot="footer" class="checkfooter">
                    <el-button @click="notCheckAnswer">不查看</el-button>
                    <el-button type="primary" @click="confrimCheckAnswer"
                        >查看</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    GetMedicalQueationDetailByChapterId,
    AddQuestionLog,
    MyCollection,
    MyCancelCollection,
    AddQuestionLogList,
    GetSystemCategoryInfo
} from "@/api/course";
import { GetRandomExam } from "@/api/exam";
import SheetCard from "@/components/sheetCardPractice";
// 组卷模考
export default {
    props: {
        topicInfo: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        SheetCard
    },
    data() {
        return {
            orginObj: {},
            dataList: [],
            sheetList: [],
            passColumName: "",
            chapterList: [],
            fillAnswer: "",
            yourAnswer: "",
            isReadonly: false,
            currentOrder: 0,
            allTopicNum: 0,
            passList: [],
            overList: [],
            isHaveDo: {},
            centerDialogVisible: false,
            checkAnswer: false,
            isSubMitPaper: false,
            errTopicNum: "",
            getScore: "",
            makeRight: 0,
            makeErr: 0,
            totalTopic: 0,
            isHaveSubmit: false,
            topicTypes: [],
            colums: []
        };
    },
    computed: {},
    watch: {},
    created() {
        this.passColumName = this.topicInfo.columName;
        if (this.topicInfo.allQuestions === 1) {
            this.GetMedicalQueationDetailByChapterId();
        } else {
            this.GetSystemCategoryInfo();
        }
    },
    mounted() {},
    methods: {
        async GetSystemCategoryInfo() {
            try {
                const { data } = await GetSystemCategoryInfo();
                this.colums = data.data;
                await this.GetRandomExam();
            } catch (err) {
                this.$message("删除发生异常！", "error");
            }
        },
        cycDelChild(arrMap, arr, c) {
            arr.forEach((v, i) => {
                if (v.id === c.category_id) {
                    c.categoryName = v.name;
                    arrMap.push(c);
                } else if (v.children && v.children.length !== 0) {
                    this.cycDelChild(arrMap, v.children, c);
                }
            });
        },
        // 把正确答案转化成字符串
        TransformAnswer(val) {
            let arr = val;
            if (arr.length !== 0) {
                let str = arr.join("");
                return str;
            } else {
                return "未作答";
            }
        },
        returnback() {
            this.isHaveSubmit = false;
            this.$router.back();
        },
        // 公共题库做题
        async GetMedicalQueationDetailByChapterId() {
            try {
                const { data } = await GetMedicalQueationDetailByChapterId({
                    chapterId:
                        this.topicInfo.info.sourceId || this.topicInfo.info.id,
                    pageno: 1,
                    pagesize: 99999
                });
                let arr = data.data;
                arr.forEach((v, i) => {
                    // 题型
                    if (v.SubjectType === "3") {
                        // console.log("填空", i);
                    }
                    if (v.analysis === "<br /><br />" || !v.analysis || (typeof v.analysis === "string" && v.analysis.match(/^[ ]*$/))) {
                        v.analysis = "";
                    }
                    v.showAnwser = false;
                    v.isErr = null;
                    if (v.answer) {
                        v.answer = JSON.parse(v.answer);
                        v.answer.forEach((c) => {
                            c.rankStyle = null; // 点击选择的时候样式
                            c.userIsErrStyle = null; // 用户答错的样式
                            c.answerIsErr = false; // 当前选项是否答对
                            c.origlRight = false; // 原始状态是对的选项
                            c.SubjectAnswer = ""; // 原始状态是对的选项
                        });
                    }
                });
                this.dataList = arr;
                this.dataList.forEach((v, i) => {
                    v.status = 0;
                    v.order = parseInt(i) + 1;
                });

                // 列表做第一个没有做的题的序号
                let num = this.dataList.findIndex((item) => {
                    return !item.status;
                });
                this.currentOrder = num;
                this.orginObj = this.dataList[num];
                this.allTopicNum = this.dataList.length;
                this.passList = this.dataList;
                this.$forceUpdate();
            } catch (err) {
                console.log(err);
            }
        },
        cancelTestPaper() {
            this.centerDialogVisible = false;
        },
        // 确认交卷
        confrimPaper() {
            this.correctPaper(this.dataList);
        },
        // 交卷
        testOver() {
            if (this.isHaveSubmit) {
                return this.$message({
                    type: "warning",
                    message: "不能重复提交"
                });
            }
            this.centerDialogVisible = true;
        },
        notCheckAnswer() {
            this.centerDialogVisible = false;
            this.returnback();
        },
        confrimCheckAnswer() {
            this.centerDialogVisible = false;
            this.checktopicAnswer(this.dataList);
        },

        // 查看答案
        checktopicAnswer(arr) {
            arr.forEach((v) => {
                v.status = 1;
                v.showAnwser = true;
                v.userSelectAnswer = [];
                if (
                    v.SubjectType === "1" ||
                    v.SubjectType === "2" ||
                    v.SubjectType === "4"
                ) {
                    if (v.answer) {
                        v.answer.forEach((c) => {
                            if (c.rightFlag === "1") {
                                c.origlRight = 1;
                            }
                            if (c.rankStyle) {
                                v.userSelectAnswer.push(c.option);
                            }

                            if (c.rankStyle === 1 && c.rightFlag === "0") {
                                c.userIsErrStyle = 1;
                                // 当前答案错误
                                c.answerIsErr = true;
                            }
                            if (!c.rankStyle && c.rightFlag === "1") {
                                c.answerIsErr = true;
                            }
                        });
                        try {
                            v.answer.forEach((c) => {
                                if (c.answerIsErr) {
                                    v.isErr = 1;
                                    throw Error();
                                } else {
                                    v.isErr = 0;
                                }
                            });
                        } catch (error) {
                            console.log(error);
                        }
                    }
                } else {
                    if (v.answer) {
                        v.answer.forEach((c) => {
                            if (c.rankStyle) {
                                v.userSelectAnswer.push(c.rankStyle);
                            }
                        });
                        v.isErr = 0;
                    }
                }
            });
            console.log("arr--", arr);
            this.$forceUpdate();
        },
        // 比较答案
        correctPaper(arr) {
            arr.forEach((v) => {
                v.status = 1;
                if (v.haveDo) {
                    v.userSelectAnswer = [];
                    if (
                        v.SubjectType === "1" ||
                        v.SubjectType === "2" ||
                        v.SubjectType === "4"
                    ) {
                        if (v.answer) {
                            v.answer.forEach((c) => {
                                // if (c.rightFlag === "1") {
                                //     c.origlRight = 1
                                // }
                                if (c.rankStyle) {
                                    v.userSelectAnswer.push(c.option);
                                }

                                if (c.rankStyle === 1 && c.rightFlag === "0") {
                                    // c.userIsErrStyle = 1
                                    // 当前答案错误
                                    c.answerIsErr = true;
                                }
                                if (!c.rankStyle && c.rightFlag === "1") {
                                    c.answerIsErr = true;
                                }
                            });
                            try {
                                v.answer.forEach((c) => {
                                    if (c.answerIsErr) {
                                        v.isErr = 1;
                                        throw Error();
                                    } else {
                                        v.isErr = 0;
                                    }
                                });
                            } catch (error) {
                                console.log(error);
                            }
                        }
                    } else {
                        if (v.answer) {
                            v.answer.forEach((c) => {
                                if (c.rankStyle) {
                                    v.userSelectAnswer.push(c.rankStyle);
                                }
                            });
                            v.isErr = 0;
                        }
                    }
                }
            });
            this.overList = this.dataList;
            this.$forceUpdate();
            this.BatchSubmit(this.dataList);
        },
        // 批量提交
        BatchSubmit(arr) {
            let topicMaps = [];
            arr.forEach((v, i) => {
                if (
                    v.SubjectType === "1" ||
                    v.SubjectType === "2" ||
                    v.SubjectType === "4"
                ) {
                    if (v.isErr === 0 && v.status === 1) {
                        this.makeRight++;
                    } else if (v.isErr === 1 && v.status === 1) {
                        this.makeErr++;
                    }
                }
                let obj = {};
                if (v.haveDo) {
                    let chapter = [];
                    chapter.push(v.chapter_id);
                    let chapterList = JSON.stringify(chapter);
                    obj.id = v.id;
                    obj.name = v.stem;
                    obj.sourceType = 1;
                    obj.subjectAnswer = JSON.stringify(v.userSelectAnswer);
                    obj.dataType = 3;
                    obj.categoryName = v.categoryName;
                    obj.subjectType = v.SubjectType;
                    obj.chapterIdList = chapterList;
                    obj.isError = v.isErr;
                    obj.categoryId = v.category_id;
                    obj.classId = 0;
                    topicMaps.push(obj);
                }
            });
            this.AddQuestionLogList(JSON.stringify(topicMaps));
        },
        async AddQuestionLogList(str) {
            try {
                const { data } = await AddQuestionLogList({
                    QuestionLog: str
                });
                // 已经提交
                this.isHaveSubmit = true;
                let haveMakeNum = 0;
                this.dataList.forEach((v) => {
                    if (v.haveDo) {
                        haveMakeNum++;
                    }
                });
                this.totalTopic = this.dataList.length - haveMakeNum;
                if (data.code !== 100) {
                    this.$message.info(data.msg || "服务器异常")
                } else {
                    this.isSubMitPaper = true;
                }
            } catch (error) {
                console.log(error);
            }
        },
        collection() {
            this.dataList.forEach((v) => {
                if (v.id === this.orginObj.id) {
                    if (!v.collect) {
                        v.collect = 1;
                        this.MyCollection();
                    } else {
                        v.collect = 0;
                        this.MyCollection();
                    }
                }
            });
        },
        async MyCollection() {
            try {
                const { data } = await MyCollection({
                    id: this.orginObj.id,
                    name: this.orginObj.stem,
                    sourceType: 1,
                    type: 1,
                    categoryName: this.chapterName,
                    subjectType: this.orginObj.SubjectType
                });
            } catch (error) {
                this.$toast("服务器繁忙，请稍后再试！");
            }
        },
        testFill(val) {},
        async GetRandomExam() {
            try {
                const { data } = await GetRandomExam({
                    randomExamId: this.topicInfo.columId
                });
                let arr = data.data;
                let arrMap = [];
                arr.forEach((v, i) => {
                    if (v.SubjectListCS && v.SubjectListCS.length) {
                        v.SubjectListCS.forEach((c, i) => {
                            this.cycDelChild(arrMap, this.colums, c);
                            // arrMap.push(c)
                        });
                    }
                });
                arrMap.forEach((v, i) => {
                    // 题型
                    if (v.SubjectType === "3") {
                        // console.log("填空", i);
                    }
                    if (v.analysis === "<br /><br />" || !v.analysis || (typeof v.analysis === "string" && v.analysis.match(/^[ ]*$/))) {
                        v.analysis = "";
                    }
                    v.showAnwser = false;
                    v.isErr = null;
                    if (v.answer) {
                        v.answer = JSON.parse(v.answer);
                        v.answer.forEach((c) => {
                            c.rankStyle = null; // 点击选择的时候样式
                            c.userIsErrStyle = null; // 用户答错的样式
                            c.answerIsErr = false; // 当前选项是否答对
                            c.origlRight = false; // 原始状态是对的选项
                            c.SubjectAnswer = ""; // 原始状态是对的选项
                        });
                    }
                });
                console.log(arrMap, "arrMap");
                this.dataList = arrMap;
                this.dataList.forEach((v, i) => {
                    v.order = parseInt(i) + 1;
                });
                // 列表做第一个没有做的题的序号
                let num = this.dataList.findIndex((item) => {
                    return !item.status;
                });
                this.currentOrder = num;
                this.orginObj = this.dataList[num];
                this.allTopicNum = this.dataList.length;
                this.passList = this.dataList;
            } catch (err) {
                console.log(err);
            }
        },
        // 单选 和判断
        selectSingleAnswer(val, arr) {
            if (this.orginObj.status === 1) {
                this.$message({
                    type: "warning",
                    message: "已提交"
                });
                return;
            }
            this.orginObj.haveDo = false;
            arr.forEach((v) => {
                v.rankStyle = 1;
                if (v.option === val.option) {
                    v.rankStyle = 1;
                    this.orginObj.haveDo = true;
                    this.isHaveDo = this.orginObj;
                } else {
                    v.rankStyle = 0;
                }
            });
            this.$forceUpdate();
        },
        // 多选
        selectSomeAnswer(val, arr) {
            if (this.orginObj.status === 1) {
                this.$message({
                    type: "warning",
                    message: "已提交"
                });
                return;
            }
            if (val.rankStyle) {
                val.rankStyle = 0;
            } else {
                val.rankStyle = 1;
            }
            this.orginObj.haveDo = false;
            if (this.orginObj && this.orginObj.answer) {
                this.orginObj.answer.forEach((v) => {
                    if (v.rankStyle) {
                        this.orginObj.haveDo = true;
                        this.isHaveDo = this.orginObj;
                        return;
                    }
                });
            }
            this.$forceUpdate();
        },
        // 填空题
        FillIuput(val) {
            if (val.trim()) {
                this.orginObj.haveDo = true;
                this.isHaveDo = this.orginObj;
            }
        },
        jumpSheet(val) {
            this.currentOrder = val - 1;
            this.orginObj = this.dataList[val - 1];
        },
        preTopic() {
            if (!this.currentOrder) {
                this.$message("已到第一题");
                return;
            } else {
                this.currentOrder--;
                this.orginObj = this.dataList[this.currentOrder];
            }
        },
        nextTopic() {
            if (this.currentOrder === this.dataList.length - 1) {
                this.$message("已到最后一题");
                return;
            } else {
                this.currentOrder++;
                this.orginObj = this.dataList[this.currentOrder];
                this.$refs.sheetCard.currentOrder = this.currentOrder + 1;
            }
        },
        cofrimFill() {
            if (this.orginObj.status) {
                this.$message("请勿重复提交");
                return;
            } else {
                this.subMitAnswer();
            }
        },
        // 提交答案  暂未使用
        async subMitAnswer() {
            let userSelectAnswer = [];
            let v = this.orginObj;
            this.dataList.forEach(async (v, i) => {
                if (v.id === this.orginObj.id) {
                    if (
                        v.SubjectType === "1" ||
                        v.SubjectType === "2" ||
                        v.SubjectType === "4"
                    ) {
                        if (v.answer) {
                            v.answer.forEach((c) => {
                                if (c.rankStyle) {
                                    userSelectAnswer.push(c.option);
                                }
                                if (c.rankStyle === 1 && c.rightFlag === "0") {
                                    c.answerIsErr = true;
                                }
                                if (!c.rankStyle && c.rightFlag === "1") {
                                    c.answerIsErr = true;
                                }
                            });
                            try {
                                v.answer.forEach((c) => {
                                    if (c.answerIsErr) {
                                        v.isErr = 1;
                                        throw Error();
                                    } else {
                                        v.isErr = 0;
                                    }
                                });
                            } catch (error) {
                                console.log(error);
                            }
                        }
                    }
                    this.chapterList = [];
                    this.chapterList.push(this.orginObj.chapter_id);
                    let chapter = JSON.stringify(this.chapterList);
                    try {
                        const { data } = await AddQuestionLog({
                            id: this.orginObj.id,
                            name: this.orginObj.stem,
                            sourceType: 1,
                            subjectAnswer:
                                this.orginObj.SubjectAnswer ||
                                JSON.stringify(userSelectAnswer),
                            dataType: 3,
                            categoryName: this.orginObj.categoryName,
                            subjectType: this.orginObj.SubjectType,
                            chapterIdList: chapter,
                            isError: this.orginObj.isErr,
                            categoryId: this.orginObj.category_id,
                            classId: 0
                        });
                        this.orginObj.status = 1;
                        if (data.code !== 100) {
                            this.$message.info(data?.msg || "未知错误")
                        }
                    } catch (err) {
                        this.$toast("服务器繁忙，请稍后再试！");
                    }
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.contain {
    box-sizing: border-box;

    .back {
        margin-top: 10px;
    }

    .box {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        .left {
            background: #ffffff;
            border-radius: 12px;
            width: 850px;

            .nav {
                border-bottom: 1px solid #f1f2f6;
                height: 70px;
                padding: 20px;
                box-sizing: border-box;

                .tit {
                    ::v-deep p {
                        font-size: 14px;
                    }
                }

                .back {
                    margin: 0;
                }
                .throw {
                    width: 1px;
                    height: 18px;
                    background-color: #dcdfe6;
                    margin: 0 15px;
                }
            }

            .twoBox {
                .topicContain {
                    padding: 30px;
                    box-sizing: border-box;
                    min-height: 620px;

                    .topicNav {
                        display: flex;
                        justify-content: space-between;

                        .tit {
                            display: flex;

                            .topicType {
                                flex-shrink: 0;
                                margin-right: 13px;
                            }

                            .topicContent {
                                width: 680px;
                            }
                        }
                    }

                    .allTopics {
                        .topics {
                            margin-top: 32px;
                            margin-left: 60px;

                            .topicItem {
                                margin-bottom: 20px;

                                .options {
                                    width: 30px;
                                    height: 30px;
                                    border-radius: 50%;
                                    background: #ffffff;
                                    border: 1px solid #e5e8ec;
                                    margin-right: 10px;
                                }

                                .singleActive {
                                    background-color: #256cf4;
                                    color: white;
                                }

                                .makeRightStyle {
                                    background-color: #00b37c;
                                    color: white;
                                }

                                .isErrorActive {
                                    background-color: #f7593b;
                                    color: white;
                                }

                                .multiple {
                                    border-radius: 6px;
                                }
                            }
                        }

                        .parsingBox {
                            width: 100%;
                            border-radius: 8px;
                            border: 1px solid #e5e8ec;
                            min-height: 100px;
                            padding: 30px;
                            box-sizing: border-box;
                            font-size: 14px;

                            .showAnswerText {
                                .lfet {
                                    .your {
                                        margin-left: 70px;
                                    }
                                }
                            }

                            .parsing {
                                .tit {
                                    margin: 30px 0 20px 0;

                                    .cyc {
                                        width: 5px;
                                        height: 5px;
                                        border-radius: 50%;
                                        background: #256cf4;
                                        margin-right: 8px;
                                    }
                                }
                            }
                        }

                        .notParsingBox {
                            width: 100%;
                            border-radius: 8px;
                        }

                        .fillBlank {
                            .fillBlankItem {
                                .fillBlanktext {
                                    margin: 30px 0 20px 0;
                                }

                                ::v-deep .el-textarea__inner {
                                    min-height: 100px !important;
                                }
                            }

                            .confrimBtn {
                                width: 120px;
                                height: 40px;
                                border-radius: 8px;
                                margin: 20px 0;
                            }
                        }
                    }
                }

                .bottom {
                    padding: 25px 40px;
                    box-sizing: border-box;
                    width: 100%;
                    height: 100px;
                    box-shadow: 0px 2px 20px 0px rgba(229, 232, 236, 0.65);

                    .left {
                        .btn {
                            width: 140px;
                            height: 48px;
                            background: #edf1f5;
                            border-radius: 8px;
                        }

                        .next {
                            margin-left: 30px;
                        }
                    }

                    .rightSave {
                        .save {
                            width: 180px;
                            height: 48px;
                            background: #eff5ff;
                            border-radius: 8px;
                            border: 1px solid #256cf4;
                            font-size: 14px;
                            color: #256cf4;
                        }

                        span {
                            margin-left: 5px;
                        }
                    }
                }
            }
        }

        .rightSheet {
            width: 320px;
            min-height: 790px;
            background: #ffffff;
            border-radius: 12px;
        }
    }

    ::v-deep .el-dialog {
        height: 159px;
        background: #ffffff;
        border-radius: 10px;

        .el-dialog__header {
            padding-top: 10px;
        }

        .isOver {
            width: 100%;
            // margin-bottom: 50px;
        }

        .isOverfooter {
            margin-top: 10px;

            .el-button--default {
                width: 110px;
                height: 40px;
                border-radius: 20px;
                border: 1px solid #e5e8ec;
            }

            .el-button--primary {
                margin-left: 20px;
                width: 110px;
                height: 40px;
                background: linear-gradient(270deg, #5abbfc 1%, #256cf4 100%);
                border-radius: 20px;
            }
        }

        .overText {
            width: 100%;

            .text {
                margin-bottom: 10px;
            }
        }

        .checkfooter {
            margin-top: 10px;

            .el-button--default {
                width: 110px;
                height: 40px;
                border-radius: 20px;
                border: 1px solid #e5e8ec;
            }

            .el-button--primary {
                margin-left: 20px;
                width: 110px;
                height: 40px;
                background: linear-gradient(270deg, #5abbfc 1%, #256cf4 100%);
                border-radius: 20px;
            }
        }
    }
}
</style>
